import React from 'react';
import Avatar from 'boring-avatars';

/**
 * Reusable user avatar component.
 * - 手机 / 邮箱等登录：根据唯一标识生成 boring-avatars SVG
 * - 微信登录：使用微信头像 URL
 *
 * Props:
 *  - user: 用户对象，需包含 loginType, avatar, phone, email, id
 *  - size: number (像素尺寸)
 *  - style: 额外内联样式
 */
const UserAvatar = ({ user, size = 32, style }) => {
  // 如果用户有头像URL，直接使用
  if (user?.avatar) {
    return (
      <img
        src={user.avatar}
        alt="avatar"
        width={size}
        height={size}
        style={{ borderRadius: '50%', objectFit: 'cover', ...style }}
      />
    );
  }

  // 生成唯一 seed
  const seed = user?.phone || user?.email || String(user?.id || 'default');

  // 使用更美观的 marble 风格，配合现代渐变色方案
  // marble 风格会产生更柔和、更自然的大理石纹理效果
  return (
    <Avatar
      size={size}
      name={seed}
      variant="marble" // 大理石风格，更柔和美观
      colors={[
        "#4A90E2", // 明亮蓝色
        "#FF6B9D", // 明亮粉红色
        "#4ECDC4", // 明亮青绿色
        "#FFD93D", // 明亮黄色
        "#A78BFA", // 明亮紫色
        "#FF8E53", // 明亮橙色
        "#7ED321", // 明亮绿色
        "#FF4757"  // 明亮红色
      ]}
      style={style}
    />
  );
};

export default UserAvatar;